import {
  FC,
  ReactNode,
  useMemo,
} from "react";

import { IdContext } from "./context";

type Props = {
  publicationId: string,
  unitId: string,
  children: ReactNode,
};

export const IdProvider: FC<Props> = ({
  publicationId,
  unitId,
  children,
}) => {

  const memoValue = useMemo(() => ({
    publicationId,
    unitId,
  }),[ publicationId, unitId ]);

  return (
    <IdContext.Provider value={memoValue}>
      {children}
    </IdContext.Provider>
  );
};
